import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RelationsService } from './relations.service';
import { RelationDTO } from './dto/relation.dto';
import { RelationResponseModel,AllRelationsResponseModel } from '@gtpl/shared-models/masters';
import { RelationRequest } from './dto/relation.request';

@ApiTags('relations')
@Controller('relations')
export class RelationsController {
    constructor(
        private relationsService: RelationsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
   /**
     * creates or updates a value of relation
     * @param relationDto relation DTO
     * @returns relationResponse
     */
    @Post('/createRelation')
    async createRelation(@Body() relationDTO:RelationDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RelationResponseModel> {
        try {
            // console.log(relationDTO);
            return await this.relationsService.createRelation(relationDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RelationResponseModel, error)
        }
    }

    /**
     * creates or updates a value of relation
     * @param relationDto relation DTO
     * @returns relationResponse
     */
    @Post('/updateRelation')
    async updateRelation(@Body() departmentsDTO: RelationDTO,@Req() request:Request): Promise<RelationResponseModel> {
        try {
        return await this.relationsService.createRelation(departmentsDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RelationResponseModel, error)
        }
    }

      /**
     * gets all the Value of relations
     * @returns AllValue RelationResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
    @Post('/getAllRelations')
    async getAllRelations(@Req() request: Request): Promise<AllRelationsResponseModel> {
        try {
        return await this.relationsService.getAllRelations();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllRelationsResponseModel, error)
        }
    }

     /**
     * Activate Or De-Activate Value Relation
     * @param getSingleDepartment RelationResponseModel 
     * @returns Value Department
     */
    @Post('/activateorDeactivateRelation')
    async activateorDeactivateRelation(@Body() departmentReq: RelationRequest): Promise<RelationResponseModel> {
        try {
            return await this.relationsService.activateorDeactivateRelation(departmentReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(RelationResponseModel, err);
        }
    }
}
